<template>
  <div class="row border-bottom border-bottom-1 border-gray-200 py-10">
    <Input
        containerClass="col-12 col-md-4"
        :name="`recurrent-expense-amount-${id}`"
        type="text"
        :label="$t('recurrentExpense.label.amount')"
        labelClass="form-label fs-6 text-black"
        :inputClass="'form-control form-control-sm form-control-solid'"
        :isRequired="true"
        size="lg"
        :placeholder="$t('recurrentExpense.placeholder.amount')"
        v-model="feeData.amount"
        :IsInputGroup="true">
      <template #rightAddon>
          <span class="position-absolute end-0 top-50 translate-middle-y me-3 text-muted fw-bolder">
            {{ currency }}
          </span>
      </template>
    </Input>
    <Select2
        container-class="form-group col-12 col-md-6 mb-7"
        :multiple="false"
        :show-search="true"
        :selectClass="'form-select form-control-sm form-select-solid'"
        :name="`recurrent-expense-reason`+id"
        :label="$t('recurrentExpense.label.reason')"
        labelClass="form-label fs-6 text-black"
        :placeholder-text="$t('recurrentExpense.label.reason')"
        v-model="feeData.reason_id"
        :IsInputGroup="true"
        icon="bi bi-plus"
        :clickAddon="openReasonModal">
      <option v-for="reason in reasons" :value="reason.id" :key="reason.id">
        {{ reason.name }}
      </option>
    </Select2>
    <div v-if="showFile" class="col-10 d-flex flex-column justify-content-center">
      <label class="form-label fs-6 fw-bolder text-black"> {{ $t('expense.label.receipt') }} </label>
      <input
          class="d-none"
          ref="fileInput"
          type="file"
          :name="`expense-reason-${id}-file`"
          :id="`input-expense-reason-${id}-file`"
          @change="handleUpload"
      />
      <div>
        <button class="btn btn-sm btn-light-primary rounded w-150px h-35px" type="button" @click.prevent="triggerFileInput">
          <i class="bi bi-paperclip fs-4"></i>
          {{ $t('expense.label.attachFiles') }}
        </button>
        <small class="ms-2"> {{ $t('expense.placeholder.attachFiles') }} </small>
        <div class="d-flex flex-wrap mt-3">
          <Card class="mx-2" v-for="(file, index) in feeData.invoices">
            <div class="d-flex justify-content-between align-items-center p-3">
              <i class="bi bi-file-earmark text-primary fs-4 me-3"></i>
              {{ file.name }}
              <i class="bi bi-x fs-2 ms-3 cursor-pointer" @click.prevent="removeFile(index)"></i>
            </div>
          </Card>
        </div>
      </div>

    </div>
    <div v-if="index" class="col-2 mt-10 mb-7">
      <a class="btn btn-sm btn-icon btn-danger p-5" @click.prevent="deleteReasonRow(index)">
        <i class="bi bi-trash-fill fs-5"></i>
      </a>
    </div>
  </div>

  <CreateReasonModal :id="'reason-create-modal'+id" />
</template>

<script setup>

import Select2 from "@/components/Select2.vue";
import {computed, defineEmits, defineProps, ref} from "vue";
import Input from "@/components/Input.vue";
import {useStore} from "vuex";
import CreateReasonModal from "@/Modules/Financial/components/Modals/Reason/CreateReasonModal.vue";
import Card from "@/components/Card.vue";

const store = useStore()
const emits = defineEmits(["deleteRow"])
const props = defineProps({
  showFile: { type: Boolean, default: false },
  fee: {
    type: Object,
    default: () => ({
      id: '',
      amount: 0,
      reason_id: '',
      invoices: []
    })
  },
  currency: String,
  index: Number,
  id: String,
})

const feeData = ref(props.fee)
const file = ref('')
const reasons = computed(() => store.getters['reason/reasons'])

const openReasonModal = () => {
  $('#reason-create-modal'+props.id).modal('toggle')
}
function deleteReasonRow(index) {
  emits('deleteRow', index)
}

const triggerFileInput = () => {
  $(`#input-expense-reason-${props.id}-file`).click()
}

const removeFile = (index) => {
  feeData.value.invoices.splice(index, 1)
}

const handleUpload = (e) => {
  feeData.value.invoices.push(e.target.files[0])
  file.value = ''
}

</script>

<style scoped>
</style>
